import React, { useState } from "react";
import { useIntl } from "react-intl";
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";

import { faPlusCircle, faSyncAlt } from "@fortawesome/free-solid-svg-icons";

import Card from "../../UI/Card/Card";
import ApplicationsList from "./ApplicationsList";
import Headline from "../../Headline/Headline";
import Button from "../../UI/Button/Button";
import ErrorPanel, { ErrorSize } from "../../UI/ErrorPanel/ErrorPanel";
import EmptyState from "../../UI/State/EmptyState";

import * as ApplicationConstant from "../../Constants/ApplicationConstant";
import * as CommonActions from "../../../middleware/Store/Actions/CommonActions";
import * as ContactUtils from "../../Utils/ContactUtils";
import styles from "./Applications.module.scss";
import LogService from "../../../middleware/CommonSdk/LogService";

const LOG_TAG = "APPLICATIONS";

const Applications = (props) => {
    const intl = useIntl();
    const history = useHistory();
    const [errorMessage, setErrorMessage] = useState("");

    const handleCreateApplication = () => {
        LogService.trace(LOG_TAG, "handleCreateApplication");
        history.push(ApplicationConstant.APPLICATION_PATH + ApplicationConstant.CREATE_PATH);
    }

    const handleOnApplicationsRefresh = () => {
        LogService.trace(LOG_TAG, "handleOnApplicationsRefresh");
        if (props.getDevelopersAndApplications) {
            props.getDevelopersAndApplications()
                .then(() => {
                    LogService.info(LOG_TAG, "handleOnApplicationsRefresh", "success");
                    setErrorMessage("");
                })
                .catch(() => {
                    LogService.error(LOG_TAG, "handleOnApplicationsRefresh", "error");
                    setErrorMessage(intl.messages.applicationsRetrieveErrorMessage);
                });
        }
    }

    LogService.trace(LOG_TAG, "render");

    const title = intl.messages.applicationsTitle;
    const subtitle = intl.messages.applicationsMessage;

    let contentDisplay = null;
    let footerDisplay = null;
    
    if (props.progress) {
        contentDisplay = <EmptyState progress={true} text="" />;
    } else {
        contentDisplay = []; footerDisplay=[];
        contentDisplay.push(
            <ApplicationsList
                key="1"
                onApplicationsRefresh={handleOnApplicationsRefresh}
            />
        );

        if (ContactUtils.isDeveloper(props.user) || ContactUtils.isSuperAdminOrAppSuperAdmin(props.user)) {
            footerDisplay.push(
                <Button
                    key="2"
                    id="createApplicationButtonId"
                    label={intl.messages.applicationCreateButton}
                    icon={faPlusCircle}
                    className="btn-submit mt-3"
                    onClick={handleCreateApplication}
                />
            );
        }

        if (props.applications?.length === 0)
        footerDisplay.push(
                <Button
                    key="3"
                    id="refreshApplicationButtonId"
                    label={intl.messages.refresh}
                    icon={faSyncAlt}
                    className="btn-submit mt-3 ml-2"
                    onClick={handleOnApplicationsRefresh}
                />
            );

        if (errorMessage)
            contentDisplay.push(
                <div key="4">
                    <ErrorPanel size={ErrorSize.Small} >{errorMessage}</ErrorPanel>
                </div>
            );
    }

    return (
        <div>
            <Headline
                title={title}
                subtitle={subtitle}
            />

            <Card title={intl.messages.applicationsCardTitle}>
                <div className={styles.applicationList}>
                    {contentDisplay}
                </div>
                <div className="card-footer text-left">{footerDisplay}</div>
            </Card>
        </div>
    );
}

Applications.defaultProps = {
}

Applications.propTypes = {
};

const mapStateToProps = state => {
    return {
        user: state.contacts.user,
        applications: state.applications.applications,
        progress: state.applications.progress
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getDevelopersAndApplications: () => dispatch(CommonActions.getDevelopersAndApplications()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Applications);